import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import { MyContext } from '../../../../Context/MyContext';
import logo from '../../../../Assets/logo.png';
import NotificationBell from '../../../../Components/NotificationBell';
import AppIcon from '../../../../Components/AppIcon';


// ── Post Type Modal ───────────────────────────────────────────
const POST_OPTIONS = [
  {
    id: 'property',
    label: 'Add a Property',
    description: 'Post your residential or commercial property for sale or rent.',
    path: '/role?context=property',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="32" height="32">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    id: 'project',
    label: 'Add a Project',
    description: 'Showcase your new launch, villa project, or development venture.',
    path: '/role?context=project',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="32" height="32">
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <path d="M8 21h8M12 17v4" />
        <path d="M7 8h2m2 0h2m2 0h2" />
        <path d="M7 12h10" />
      </svg>
    ),
  },
];

const PostModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);
  if (!open) return null;

  const handleSelect = (opt) => {
    onClose();
    navigate(opt.path);
  };


  return (
    <div className="pm-back" onClick={onClose}>
      <div className="pm-box" onClick={e => e.stopPropagation()}>
        <div className="pm-head">
          <p className="pm-title">What Would You Like to List?</p>
          <button className="pm-close" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div className="pm-options">
          {POST_OPTIONS.map(opt => (
            <button key={opt.id} className="pm-opt" onClick={() => handleSelect(opt)}>
              <span className="pm-opt-icon">{opt.icon}</span>
              <span className="pm-opt-body">
                <span className="pm-opt-label">{opt.label}</span>
                <span className="pm-opt-desc">{opt.description}</span>
              </span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18" className="pm-opt-arrow">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
          ))}
        </div>
        <p className="pm-free-note">
          <AppIcon name="sparkle" size={14} /> 100% Free Listing
        </p>
      </div>
    </div>
  );
};

// ── City Selector ──────────────────────────────────────────────
const CitySelector = () => {
  const { cities, selectedCity, changeCity } = useContext(MyContext);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ddRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ddRef.current && !ddRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = (cities || []).filter(c => c.city && c.city.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="city-selector-wrap" ref={ddRef} style={{ position: 'relative', marginLeft: '12px' }}>
      <button 
        className="city-selector-btn" 
        onClick={() => { setOpen(!open); setSearch(''); }}
        style={{
           display: 'flex', alignItems: 'center', gap: '6px',
           padding: '7px 12px', borderRadius: '8px', border: '1.5px solid #eee',
           background: '#f9fafb', fontSize: '13px', fontWeight: '600',
           color: '#1e293b', cursor: 'pointer', whiteSpace: 'nowrap',
           outline: 'none'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
        {selectedCity ? selectedCity.city : 'All Cities'}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="12" height="12" style={{ transform: open ? 'rotate(180deg)' : 'none', transition: '0.2s' }}>
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 8px)', left: '0',
          width: '220px', background: '#fff', border: '1px solid #eaeaea',
          borderRadius: '12px', boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
          zIndex: 1000, overflow: 'hidden', display: 'flex', flexDirection: 'column'
        }}>
          <div style={{ padding: '10px', borderBottom: '1px solid #eaeaea' }}>
            <input 
              type="text" 
              placeholder="Search city..." 
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: '100%', padding: '8px 12px', borderRadius: '6px',
                border: '1px solid #ddd', fontSize: '13px', outline: 'none'
              }}
              autoFocus
            />
          </div>
          <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
            <button 
              onClick={() => { changeCity(null); setOpen(false); }}
              style={{
                width: '100%', padding: '10px 14px', textAlign: 'left',
                background: !selectedCity ? '#eff6ff' : '#fff',
                color: !selectedCity ? '#2563eb' : '#333',
                border: 'none', borderBottom: '1px solid #f5f5f5',
                fontSize: '13px', fontWeight: '500', cursor: 'pointer'
              }}
            >
              All Cities
            </button>
            {filtered.length === 0 && (
              <div style={{ padding: '12px 14px', fontSize: '13px', color: '#888', textAlign: 'center' }}>No cities found</div>
            )}
            {filtered.map(c => (
              <button 
                key={c.id}
                onClick={() => { changeCity(c); setOpen(false); }}
                style={{
                  width: '100%', padding: '10px 14px', textAlign: 'left',
                  background: selectedCity?.id === c.id ? '#eff6ff' : '#fff',
                  color: selectedCity?.id === c.id ? '#2563eb' : '#333',
                  border: 'none', borderBottom: '1px solid #f5f5f5',
                  fontSize: '13px', fontWeight: '500', cursor: 'pointer'
                }}
              >
                {c.city}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// ── Header ────────────────────────────────────────────────────
const Header = () => {
  const { navLinks } = useContext(MyContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [openDD, setOpenDD] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [loginTip, setLoginTip] = useState(false);
  const ddRef = useRef(null);
  const { user } = useContext(MyContext)
  const isHome = location.pathname === '/';

 useEffect(() => {
  const onScroll = () => {
    setScrolled(window.scrollY > 50); // increase threshold
  };

  window.addEventListener('scroll', onScroll);

  // IMPORTANT: run once on load
  onScroll();

  return () => window.removeEventListener('scroll', onScroll);
}, []);

  useEffect(() => {
    const handler = (e) => {
      if (ddRef.current && !ddRef.current.contains(e.target)) setOpenDD(null);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    if (user) {
      setLoginTip(false);
      return undefined;
    }
    let hideTimer;
    const show = () => {
      setLoginTip(true);
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => setLoginTip(false), 5000);
    };
    show();
    const cycle = setInterval(show, 10000);
    return () => {
      clearTimeout(hideTimer);
      clearInterval(cycle);
    };
  }, [user]);

  const isActive = (path) => {
  const [pathname, search] = path.split('?');

  return (
    location.pathname === pathname &&
    (search ? location.search.includes(search) : true)
  );
};
  const activePath = location.pathname;

  return (
    <>
      {/* ══════════════════════════════════════
          DESKTOP HEADER  (hidden on mobile)
      ══════════════════════════════════════ */}
      <header
  className={`header desktop-header ${
    isHome
      ? (scrolled ? 'header-scrolled' : '')
      : 'header-scrolled'   // always expanded on other pages
  }`}
>
        <div className="header-inner">
          {/* Logo */}
          <Link to="/" className="header-logo">
            <img src={logo} alt="Properties In Finite" className="logo-img" />
          </Link>

          {/* Nav */}
          <nav className="header-nav" ref={ddRef}>
            {navLinks.map((link) => {
              if (link.type === 'link') {
                return (
                  <Link key={link.id} to={link.path}
                    className={`nav-link ${isActive(link.path) ? 'nav-link-active' : ''}`}>
                    {link.label}
                  </Link>
                );
              }
              if (link.type === 'dropdown') {
                return (
                  <div key={link.id} className="nav-dropdown-wrap">
                    <button
                      className={`nav-link nav-dropdown-btn ${link.children.some(c => isActive(c.path)) ? 'nav-link-active' : ''}`}
                      onClick={() => setOpenDD(openDD === link.id ? null : link.id)}
                    >
                      {link.label}
                      <svg className={`dd-chevron ${openDD === link.id ? 'open' : ''}`}
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="13" height="13">
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </button>
                    {openDD === link.id && (
                      <div className="nav-dropdown">
                        {link.children.map(child => (
                          <Link key={child.id} to={child.path}
                            className={`dd-item ${isActive(child.path) ? 'dd-item-active' : ''}`}
                            onClick={() => setOpenDD(null)}>
                            {child.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              }
              return null;
            })}
          </nav>

          {/* Actions */}
          <div className="header-actions">
            {user && <NotificationBell />}

            {user ? (
              <button
                className="btn-account"
                onClick={() => navigate('/account')}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                Account
              </button>
            ) : (
              <div className="login-tip-anchor">
                <button
                  className={`btn-account${loginTip ? ' is-login-hint' : ''}`}
                  onClick={() => navigate('/login', { state: { from: location } })}
                >
                  Login
                </button>
                {loginTip && (
                  <div className="login-tip" role="tooltip">
                    <p>Log in to save properties and contact owners.</p>
                  </div>
                )}
              </div>
            )}

            <button
              className="btn-post"
              onClick={() => {
                if (!user) {
                  navigate("/login");
                } else {
                  setPostModal(true);
                }
              }}
            >
              + Post Property <span className="btn-free-badge">FREE</span>
            </button>

          </div>
        </div>
      </header>

      {/* ══════════════════════════════════════
          MOBILE TOP BAR  (logo + post btn)
      ══════════════════════════════════════ */}
      <header className={`mobile-top-bar ${scrolled ? 'header-scrolled' : ''}`}>
        <Link to="/" className="header-logo">
          <img src={logo} alt="Properties In Finite" className="logo-img" />
        </Link>
        <button className="btn-post mobile-post-btn" onClick={() => setPostModal(true)}>
          + Post <span className="btn-free-badge">FREE</span>
        </button>
      </header>

      {/* ══════════════════════════════════════
          MOBILE BOTTOM NAV
      ══════════════════════════════════════ */}
      <nav className="mobile-bottom-nav">
        <Link to="/" className={`mbn-item ${activePath === '/' ? 'mbn-active' : ''}`}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="22" height="22">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <span>Home</span>
        </Link>

        <Link to="/properties" className={`mbn-item ${activePath === '/properties' ? 'mbn-active' : ''}`}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="22" height="22">
            <rect x="2" y="7" width="20" height="14" rx="2" />
            <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
            <line x1="12" y1="12" x2="12" y2="16" />
            <line x1="10" y1="14" x2="14" y2="14" />
          </svg>
          <span>Properties</span>
        </Link>

        {/* Center + Post button → opens modal */}
        <button className="mbn-center-btn" onClick={() => setPostModal(true)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="26" height="26">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>



        <Link to="/account" className={`mbn-item ${activePath === '/account' ? 'mbn-active' : ''}`}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="22" height="22">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <span>Profile</span>
        </Link>

        <div
          className="mbn-item"
          onClick={() => setShowMore(!showMore)}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="22" height="22">
            <circle cx="5" cy="12" r="1.5" />
            <circle cx="12" cy="12" r="1.5" />
            <circle cx="19" cy="12" r="1.5" />
          </svg>
          <span>More</span>
        </div>
        {showMore && (
          <div className="mbn-more-menu">
            <Link to="/about" onClick={() => setShowMore(false)}>About Us</Link>
            <Link to="/privacy-policy" onClick={() => setShowMore(false)}>Privacy Policy</Link>
            <Link to="/contact" onClick={() => setShowMore(false)}>Contact Us</Link>
            <Link to="/terms" onClick={() => setShowMore(false)}>Terms & Conditions</Link>
          </div>
        )}



      </nav>

      {/* Post modal */}
      <PostModal open={postModal} onClose={() => setPostModal(false)} />
    </>
  );
};

export default Header;